import Image, { StaticImageData } from 'next/image';
import { useEffect, useRef, useState } from 'react';
const MULBERRY = '#7A0534';
const HOLD_MS = 2500;
const FADE_MS = 350;
export type FlashSaleInfoItem = {
  icon: StaticImageData;
  label: string;
};
interface Props {
  items: [FlashSaleInfoItem, FlashSaleInfoItem];
}
const FlashSaleInfoRow = ({
  icon,
  label
}: {
  icon: StaticImageData;
  label: string;
}) => <div className="flex items-center gap-0.5 h-[14px] min-w-0 w-full" data-sentry-component="FlashSaleInfoRow" data-sentry-source-file="FlashSaleAlternatingInfo.tsx">
    <span className="flex justify-center items-center rounded-sm w-3 h-3 overflow-hidden shrink-0" style={{
    backgroundColor: MULBERRY
  }}>
      <Image src={icon} alt="" width={10} height={10} className="w-2.5 h-2.5" data-sentry-element="Image" data-sentry-source-file="FlashSaleAlternatingInfo.tsx" />
    </span>
    <span className="flex-1 min-w-0 text-[10px] leading-[14px] truncate" style={{
    color: MULBERRY
  }}>
      {label}
    </span>
  </div>;
const FlashSaleAlternatingInfo = ({
  items
}: Props) => {
  const [primary, secondary] = items;
  const [showPrimary, setShowPrimary] = useState(true);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    const schedule = (delay: number, next: () => void) => {
      timeoutRef.current = setTimeout(next, delay);
    };
    const cycle = () => {
      setShowPrimary(prev => !prev);
      schedule(HOLD_MS, cycle);
    };
    schedule(HOLD_MS, cycle);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return <div className="relative w-full h-[14px]" data-sentry-component="FlashSaleAlternatingInfo" data-sentry-source-file="FlashSaleAlternatingInfo.tsx">
      <div className="absolute inset-0 transition-opacity ease-in-out" style={{
      opacity: showPrimary ? 1 : 0,
      transitionDuration: `${FADE_MS}ms`
    }}>
        <FlashSaleInfoRow icon={primary.icon} label={primary.label} data-sentry-element="FlashSaleInfoRow" data-sentry-source-file="FlashSaleAlternatingInfo.tsx" />
      </div>
      <div className="absolute inset-0 transition-opacity ease-in-out" style={{
      opacity: showPrimary ? 0 : 1,
      transitionDuration: `${FADE_MS}ms`
    }}>
        <FlashSaleInfoRow icon={secondary.icon} label={secondary.label} data-sentry-element="FlashSaleInfoRow" data-sentry-source-file="FlashSaleAlternatingInfo.tsx" />
      </div>
    </div>;
};
export default FlashSaleAlternatingInfo;